import { useMemo } from "react";
import starsBackground from "../../assets/lander/space.webp";

export default function CommonBackground({
	className,
	children,
}: React.PropsWithChildren<{ className?: string }>) {
	return useMemo(
		() => (
			<div className={`relative ${className}`}>
				<div className="absolute -left-25 -top-25 w-[250px] h-[250px] rounded-full blur-[128px] bg-amber-400/35" />
				<img
					alt="Stars Background"
					src={starsBackground}
					className="absolute w-full h-full object-cover opacity-15 -z-1 bg-black"
				/>
				{children}
			</div>
		),
		[children, className],
	);
}
